import Bugsnag from '@bugsnag/js';
import BugsnagPluginReact from '@bugsnag/plugin-react';
import { isAxiosError } from 'axios';

import { getFullStorySessionUrl } from './fullStory';

const initBugSnag = () => {
  if (process.env.NEXT_PUBLIC_BUGSNAG_ENABLED !== 'true') {
    return;
  }

  Bugsnag.start({
    apiKey: process.env.NEXT_PUBLIC_BUGSNAG_KEY,
    plugins: [new BugsnagPluginReact()],
    releaseStage: process.env.NEXT_PUBLIC_ENV,
    appVersion: process.env.VERSION,
    // appType: config.BUILD_TARGET,
    trackInlineScripts: false,
    onError: (event) => {
      const firstError = event.errors[0];
      const isAxiosErrorType = isAxiosError(firstError);

      // @TODO: Remove this fallback once we confirm which one is correct
      if (
        (isAxiosErrorType && ['Request aborted', 'Network Error', 'Timeout error'].includes(firstError?.errorMessage))
        || ['AxiosError: Request aborted', 'AxiosError: Network Error', 'AxiosError: Timeout error'].includes(firstError?.errorMessage)
      ) {
        return false;
      }

      const sessionUrl = getFullStorySessionUrl();
      if (sessionUrl) {
        event.addMetadata('fullstory', {
          urlAtTime: sessionUrl,
        });
      }

      // @TODO: Remove this metadata once we confirm that Axios errors are not being reported
      event.addMetadata('isAxiosError', {
        isAxiosError: isAxiosErrorType,
        firstErrorMessage: isAxiosErrorType ? firstError?.message :firstError?.errorMessage,
      });
    },
  });
};

const isBugSnagInitialised = () => Bugsnag.isStarted();

const stopBugSnag = () => {
  if (isBugSnagInitialised()) {
    Bugsnag.pauseSession();
  }
};

export { initBugSnag, isBugSnagInitialised, stopBugSnag };
